<template>
  <div>
    <BankAccountDeleteModal v-if="selectedAccount" :show-modal="showDeleteModal" @close="showDeleteModal = false" @account-deleted="showDeleteModal = false" />
    <BankConnectionModal :show-modal="showModal" @close="showModal = false;loading = false" :existingBeIban="existingBeIban" />
    <BankConnectionModalTinkUP :show-modal="showModalTinkUP" @close="showModalTinkUP = false;loading = false" />

    <TitleBar>
      <template v-slot:title>{{ $gettext('Bank Transactions') }}</template>
      <template v-slot:buttons>
        <OnboardingIntroLink :onboarding-intro="'onboarding_web_bank'" />
        <GekkoButton 
          v-if="!showBankAccountEnablenow"
          @click="tryUpdateTransactionsTinkUP" 
          :text="$gettext('Update transactions')"
          :disabled="!selectedAccount"
          class="mr-2"
        />

        <!-- TODO should we show the update transactions button with enablenow ? -->
        <!-- v-if="bankAccounts.length && !bankAccounts[0].enablenow_connection_status" -->
        <GekkoButton 
          v-if="showBankAccountEnablenow"
          @click="tryUpdateTransactions" 
          :text="$gettext('Update transactions')"
          :disabled="!selectedAccount"
          class="mr-2"
        />

        <b-dropdown :key="showBankAccountEnablenow" class="icon-toggle ui-dashboard-menu-dropdown" variant="outline-primary" right no-caret>
          <template #button-content>
            <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
          </template>
          <b-dropdown-item :to="{ name: 'CashFlow' }">
            <font-awesome-icon icon="fa-solid fa-chart-column" />
            <span v-translate>Cash flow report</span>
          </b-dropdown-item>
          <b-dropdown-item @click="exportAsExcel()">
            <font-awesome-icon icon="fa-solid fa-download" />
            <span v-translate>Export as Excel</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="!showBankAccountEnablenow" @click="showModalTinkUP = true">
            <font-awesome-icon icon="fa-solid fa-plus" />
            <span v-translate>Add bank account</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="showBankAccountEnablenow" @click="showModal = true">
            <font-awesome-icon icon="fa-solid fa-plus" />
            <span v-translate>Add bank account</span>
          </b-dropdown-item>
          <b-dropdown-item @click="showDeleteModal = true">
            <font-awesome-icon icon="fa-solid fa-trash-can" />
            <span v-translate>Delete bank account</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </TitleBar>

    <div v-if="showWarningButton && !showFailureMessage" class="w-100 content-wrap" style="padding: 1.5rem 1rem; padding-top: 0;">
      <b-alert show class="gk-alert mb-0" variant="warning">
        <div class="grace-payment-alert">
          <p class="mb-0">{{ $gettext('Your bank connection is about to expire!') }}</p>
          <GekkoButton @click="showModal = true" :text="$gettext('Click to reconnect')" />
        </div>
      </b-alert>
    </div>

    <div v-if="showFailureMessage" class="w-100 content-wrap" style="padding: 1.5rem 1rem; padding-top: 0;">
      <b-alert show class="gk-alert mb-0" variant="warning">
        <div class="grace-payment-alert">
          <p class="mb-0">{{ $gettext('Your connection request failed!') }}</p>
          <GekkoButton @click="showModal = true" :text="$gettext('Click to reconnect')" />
        </div>
      </b-alert>
    </div>

    <div v-if="showRefreshMessage" class="w-100 content-wrap" style="padding: 1.5rem 1rem; padding-top: 0;">
      <b-alert show class="gk-alert mb-0" variant="warning">
        <div class="grace-payment-alert">
          <p class="mb-0">{{ $gettext('We requested an update on your bank account transactions') }}</p>
        </div>
      </b-alert>
    </div>

    <div class="content" v-if="!loading">
      <div v-if="tinkStatus && !tinkStatus.is_premium" class="gk-tip gk-tip--warning gk-tip--premium mb-3">
        <span v-if="premiumTimeLeft > 0" v-translate>
          You have {{ premiumTimeLeft }} days left of your free trial. Please
            <a href="/subscriptions/manage/">consider upgrading</a> to continue using this feature.
        </span>
        <span v-else v-translate>
          The free trial has expired, please <a href="/subscriptions/manage/">consider upgrading</a> to continue using this feature.
        </span>
      </div>
      <BankTransactions v-if="showTransactions" @update-transactions="updateTransactions" ref="BankTransactions"/>
      <div v-else class="content--inner">
        <EmptyState>
          <template v-slot:image>
            <img src="/static/img/empty-states/empty-state-cost.png">
          </template>
          <template v-slot:title>
            {{ $gettext('You dont have any bank connection configured.') }}
          </template>
          <template v-slot:content>
            {{ $gettext('Do you want to integrate you bank transactions in your accounting?') }}
          </template>
          <template v-slot:cta>
            <GekkoButton 
              v-if="!showBankAccountEnablenow"
              @click="showModalTinkUP = !showModalTinkUP" 
              :text="$gettext('Add new connection')"
              icon="fa-solid fa-plus"
            />
            <GekkoButton 
              v-if="showBankAccountEnablenow"
              @click="showModal = !showModal" 
              :text="$gettext('Add new connection')"
              icon="fa-solid fa-plus"
            />
          </template>
        </EmptyState>
      </div>
    </div>
    <div v-else>
      <LoadingSpinner :display-text="$gettext('Loading, do not refresh the page')" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import { promptDownload } from "@/utils/"

import TitleBar from "@/components/TitleBar";
import BankConnectionModal from "@/components/bank/ui/BankConnectionModal";
import BankConnectionModalTinkUP from "@/components/bank/ui/BankConnectionModalTinkUP";
import BankAccountDeleteModal from "@/components/bank/ui/BankAccountDeleteModal";
import BankTransactions from "@/components/bank/BankTransactions";
import GekkoButton from "@/components/GekkoButton";
import EmptyState from "@/components/ui/EmptyState"
import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"
import BankService from "@/store/services/bank.service.js";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import TinkService from "@/store/services/tink.service.js";

export default {
  name: "Bank",
  components: {
    TitleBar,
    BankTransactions,
    BankConnectionModal,
    BankConnectionModalTinkUP,
    BankAccountDeleteModal,
    GekkoButton,
    EmptyState,
    OnboardingIntroLink,
    LoadingSpinner
  },
  props: {

  },
  data () {
    return {
      loading: true,
      showModal: false,
      showModalTinkUP: false,

      showDeleteModal: false,
      showTransactions: true,
      
      showWarningButton: false,
      showRefreshMessage: false,
      showFailureMessage: false,

      showWarningButtonEnablenow: false,
      
      existingBeIban: null,

      tinkUP: false,
    }
  },
  computed: {
    ...mapGetters ({
      tinkStatus: "bankStore/getTinkStatus",
      getBankAccount: "bankStore/getBankAccount",
      bankAccounts: "bankStore/getBankAccounts",
      selectedAccount: "bankStore/getSelectedAccount",
      currentCompany: 'main/getCurrentCompany',
    }),
    premiumTimeLeft () {
      if(this.selectedAccount && this.selectedAccount.provider === "ENABLENOW"){
        var expiry_date = new Date(this.selectedAccount.created).addDays(30);
        var delta_seconds = (expiry_date - new Date())/1000;
        return this.secondsToDhms(delta_seconds)
      }
      return this.secondsToDhms(this.tinkStatus.premium_time_left)
    },
    showBankAccountEnablenow(){
      if(this.tinkUP){
        return false;
      }
      if(!this.selectedAccount){
        return true;
      }
      return !this.tinkUP;
    },
    isEnablenow(){
      if(!this.selectedAccount){
        return false;
      }
      return this.selectedAccount.provider === "ENABLENOW";
    },
    bankAccountIsConnected(){
      if(this.selectedAccount.connection_expiry_date === null){
        return false;
      }
      return new Date(this.selectedAccount.connection_expiry_date) > new Date();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        if (to.meta.masterModal) {
          document.body.classList.add('master-modal-on')
        } else {
          document.body.classList.remove('master-modal-on')
        }
      }
    },
    bankAccounts () {
      this.clearMessagesIfEmptyList();
    },
    selectedAccount(newVal) {
      this.checkDisplayMessages(newVal);
    }
  },
  created () {
    this.loadBankAccounts().then(() => {
      TinkService.list_credentials().then((response) => {
        TinkService.list_unifiedpost().then((response2) => {
          var temp = response.data.length + response2.data.length
          this.tinkUP = temp > 0;
          this.onBankAccountsLoaded();
        })
      })
    })
  },
  methods: {
    ...mapMutations({ setSelectedAccount: 'bankStore/SET_SELECTED_ACCOUNT' }),
    ...mapActions ({
      loadTinkStatus: "bankStore/loadTinkStatus",
      loadBankAccounts: "bankStore/loadBankAccounts",
      updateTransactions: "bankStore/updateTransactions",
      deleteBankAccount: "bankStore/deleteBankAccount"
    }),
    clearMessagesIfEmptyList() {
      if (this.bankAccounts.length < 1) {
        this.showTransactions = false;
        if(this.showBankAccountEnablenow){
          this.showModal = true;
          this.showModalTinkUP = false;
        }else{
          this.showModal = false;
          this.showModalTinkUP = true;
        }

        this.showRefreshMessage = false;
        this.showWarningButton = false;
        this.showFailureMessage = false;
      }
    },
    onBankAccountsLoaded() {
      this.loading = false;
      this.clearMessagesIfEmptyList();
    },
    checkDisplayMessages(bankAccount) {
      this.showWarningButton = false;
      this.showRefreshMessage = false;
      this.showWarningButtonEnablenow = false;
      this.showFailureMessage = false;

      console.log('bank account', bankAccount);
      let expiryDate;
      let today;
      let diff;
      let days;

      if (bankAccount && !this.bankAccountIsConnected) {
        expiryDate = Date.parse(bankAccount.connection_expiry_date);
        today = new Date();
        diff = expiryDate-today;
        days = diff/(1000 * 3600 * 24);
        this.showWarningButtonEnablenow = days < 7; // if there are less than 7 days left, show the message

      } else if (bankAccount && bankAccount.unifiedpostpaymentaccount && bankAccount.unifiedpostpaymentaccount.unifiedpostconsent) {
        this.existingBeIban = bankAccount.unifiedpostpaymentaccount.iban;

        expiryDate = Date.parse(bankAccount.unifiedpostpaymentaccount.unifiedpostconsent.expiry_date);
        today = new Date();
        diff = Math.abs(expiryDate-today); // TODO: remove absolute value?
        days = diff/(1000 * 3600 * 24);

        this.showWarningButton = days < 7; // if there are less than 7 days left, show the message

        this.showFailureMessage = bankAccount.unifiedpostpaymentaccount.unifiedpostconsent.status !== "SUCCESS";

        if (bankAccount.unifiedpostpaymentaccount.last_time_refresh_requested) {
          let lastTimeRefreshRequested = Date.parse(bankAccount.unifiedpostpaymentaccount.last_time_refresh_requested);
          diff = Math.abs(today - lastTimeRefreshRequested);
          days = diff/(1000 * 3600 * 24);

          this.showRefreshMessage = days < 0.5; // less than half a day has passed
        }
      } else if (bankAccount && !bankAccount.unifiedpostpaymentaccount && !bankAccount.tink_credential && !this.bankAccountIsConnected) {
        this.showFailureMessage = true;
      }
    },
    tryUpdateTransactionsTinkUP () {
      this.loading = true;
      this.updateTransactions().then((response) => {
        if (response === 'showModal') {
          this.showModalTinkUP = true;
        } else {
          this.checkDisplayMessages(this.selectedAccount);

          this.loadBankAccounts().then(() => {
            this.setSelectedAccount(this.selectedAccount.id)
            this.onBankAccountsLoaded()
          });
        }
      }).catch(() => {
        this.$store.commit('setAlert', {
            title: this.$gettext("Error"),
            text: this.$gettext("We could not request an update on your transaction list."),
            variant: 'danger',
            duration: 4
          });
        this.loading = false;
      });
    },
    tryUpdateTransactions() {
      const ConfirmModalConstructor = this.$options.components['confirm-modal']
      const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
          title: this.$gettext('Update transactions'),
          message: this.$gettext('You can manually update your transactions to get the latest transactions from your bank in real time. Do be aware that due to PSD2 regulations, you only have a limited number of refreshes per day.'),
          options: {
              variant: 'primary',
              confirmText: this.$gettext('Update')
          }
      }})
      confirmModalInstance.$mount()
      document.body.appendChild(confirmModalInstance.$el)
      confirmModalInstance.$on('confirmed', () => {
        const consentData = {consent_id: this.selectedAccount.external_consent_id, bank_account: this.selectedAccount.id}
        BankService.refreshEnablenowConsent(consentData).then((response) => {
          if (response.status === 201) {
            console.log('data...', response.data)
            window.location.href = response.data['redirect_url']
          } else if (response.status === 204) {
            this.showModal = true;
          } else if (response.status === 202) {
            this.$store.commit('setAlert', {
              title: this.$gettext("Consent refresh requested"),
              text: this.$gettext("Please do not refresh while we attempt to get your data."),
              variant: 'success',
              duration: 4
            })
            this.loading = true
            setTimeout(() => {
              this.onBankAccountsLoaded();
            }, 5000)
          }

          if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
              confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
          }
        }).catch((error) => {
          if (error.status === 429) {
            this.$store.commit('setAlert', {
              title: this.$gettext("Error"),
              text: this.$gettext("Too many consent refresh requests have been made. Please wait and try again later."),
              variant: 'danger',
              duration: 4
            })
          } else {
            this.$store.commit('setAlert', {
              title: this.$gettext("Error"),
              text: this.$gettext("We could not request an update on your transaction list."),
              variant: 'danger',
              duration: 4
            })
          }

          if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
              confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
          }
        })


      })
      confirmModalInstance.$on('cancel', () => {
        console.log('operation canceled')
      })

    },
    exportAsExcel () {
      const filters = this.$store.getters['filterStore/getFilter'];
      BankService.exportBank(this.selectedAccount.id, filters)
        .then(_ => {
          this.$store.commit('setAlert', {
            title: this.$gettext('Bank Download'),
            text: this.$gettext('Your download is being prepared, check your downloads page to download the file.'),
            variant: 'info',
            duration: 4
          })
          this.$router.push({ name: 'Files' })
        })
        .catch(error => {
          if (error.status === 429) {
            const alert_text = this.$gettext('You\'ve reached your download limit for today.')
            this.$store.commit('setAlert', {title: this.$gettext('Bank Download'), text:alert_text, variant:'danger',duration:4});
            this.$store.commit('togglePremiumModal', 'web_files_download_limit')
          } else {
            this.$store.commit('setAlert', {
              title: this.$gettext('Bank Download Error'),
              text: this.$gettext('An error occurred while attempting to download your bank transactions.'),
              variant: 'danger',
              duration: 4
            })
          }
        });
    },
    encodeFilterData () {
      const filters = this.$store.getters["filterStore/getFilter"]
      const str = [];
      for (var prop in filters) {
        if (Object.prototype.hasOwnProperty.call(filters, prop)) {
          str.push(encodeURIComponent(prop) + "=" + encodeURIComponent(filters[prop]));
        }
      }
      return str.join("&");
    },
    secondsToDhms (time) {
      if (!time || time < 0){
        return 0
      }
      time = Math.abs(Number(time))
      return Math.floor(time / (3600 * 24)) + 1 + ''
    }
  }
}
</script>
<style scoped lang="scss">

</style>
